import React from 'react'
import { FaqItem } from '../../components/faqitem/FaqItem'
import Page from '../../components/page/Page'

const Tou = (props) => {
    return (
        <Page id="TouPage">
            <div>
                <FaqItem
                    question={'1. Agreement'}
                    answer={
                        <div>
                            You understand that NFTHive is a third-party
                            software that provides access to the smart contracts
                            on the WAX Blockchain – and that items purchased
                            through NFTHive are not sold directly by the
                            company. They are instead sold by other users of the
                            WAX Blockchain. Transactions, buy orders, selling
                            items, bidding on auctions etc are all actions done
                            through smart contracts, that are signed with the
                            help of NFTHive but not on NFTHive. Instead NFTHive
                            provides the interface only.
                            <br />
                            Information provided by NFTHive about listings, such
                            as average prices, floor prices, number of sales are
                            not binding. They are estimates based on
                            calculations conducted by the NFTHive backend based
                            on the data gathered to the best of our ability from
                            the WAX Blockchain.
                            <br />
                            The smart contracts NFTHive interacts with, such as
                            atomicmarket, atomicassets, simpleassets,
                            simplemarket, wax.stash are not developed by the
                            Company. The contracts developed and owned by
                            NFTHive are nft.hive and waxbuyoffers.
                            <br />
                            Information about assets and collections displayed
                            on NFTHive are not provided by NFTHive directly.
                            They are taken from the blockchain and public APIs
                            such as the Atomic API. Collections and collection
                            creators alone are responsible for the content
                            provide.
                            <br />
                            Verification of collections is not done by NFTHive.
                            The verification process is also stored on the
                            blockchain and conducted by other teams. It is taken
                            from the atomhubtools contract and includes
                            collections with the status “col.verify” and
                            “col.wlist”. When you trust the NFTHive
                            verification, you understand that it does not
                            differentiate between whitelisted and verified.
                            <br />
                        </div>
                    }
                />
                <FaqItem
                    question={'2. The Service'}
                    answer={
                        <div>
                            NFTHive is a market interface offering users to
                            connect with third-party wax blockchain wallets and
                            interact with market contracts. NFTHive gathers data
                            about sales and provides analytics based on that
                            data. This is meant as a guide, but not guaranteed
                            to be correct.
                            <br />
                            Furthermore NFTHive provides a sets of tools such as
                            a set builder, offering users to complete selected
                            collections. Those are based on our own estimates
                            and are regularly updated. We do not guarantee that
                            these sets are complete or entitle you to
                            third-party giveaways or competitions.
                            <br />
                        </div>
                    }
                />
                <FaqItem
                    question={'3. Fees'}
                    answer={
                        <div>
                            Fees on NFTHive apply when selling assets through
                            our service. Fees are determined by the blockchain
                            contract and include a 1% ecosystem fee of the
                            atomicmarket contract, a 2% market fee that is split
                            by a taker and maker market, of which which NFTHive
                            can be either one or both, and a 0% - 15% collection
                            fee, that goes to the owning collection of the
                            asset. Fees do not apply when you buy listings.
                            <br />
                        </div>
                    }
                />
                <FaqItem
                    question={'4. User accounts and privacy'}
                    answer={
                        <div>
                            User Accounts are created on the WAX Blockchain,
                            either by using the WAX Cloud Wallet service or
                            third-party wallets such as Anchor Wallet or
                            Scatter. If you have access to a WAX account, you
                            have access to NFTHive by logging in through your
                            wallet.
                            <br />
                            You understand that all your transactions, purchases
                            and sales are public record. However, NFTHive does
                            not store any information about your person, other
                            than your WAX Wallet address and public transaction
                            history, and in case you chose to, your telegram
                            chat ID when you are using our telegram Notification
                            Service. Your telegram chat ID will be deleted when
                            you unlink our Telegram Bot. We do not and are not
                            able to gather information about your identity apart
                            from that.
                            <br />
                        </div>
                    }
                />
                <FaqItem
                    question={'5. Security'}
                    answer={
                        <div>
                            You agree that your account security is your own
                            responsibility. Make sure to log out when you are
                            done with the service, which disconnects your wallet
                            from NFTHive. You understand that if you are using
                            the WAX Cloud Wallet and remain logged in to your
                            account, a third party might access it and sign
                            transactions on your behalf. Always make sure to be
                            the only person that has access to your devices and
                            log out from both NFTHive and more importantly WAX
                            Cloud Wallet. Staying logged in on WCW may allow a
                            third-party to reconned to NFTHive. NFTHive has no
                            responsibility for how you use the WAX Cloud Wallet.
                            You understand that sessions may remain active when
                            you do not log out both services.
                            <br />
                            When you are using a desktop wallet and hot keys,
                            the same rules will apply. Recommended security
                            measures are to use hardware wallets such a Ledger
                            keys, which requires you to sign transactions on a
                            separate device.
                            <br />
                            NFTHive does not have access to your assets. Access
                            to your assets is provided through your wallet. You
                            are responsible to keep that access safe.
                            <br />
                            You acknowledge that when you transfer assets to a
                            smart contracts you forfeit ownership. You may send
                            assets to a smart contract when you create auctions,
                            use “staking”, craft assets, play games, open packs,
                            or create market listings. Please review the
                            transactions carefully and make sure that the smart
                            contracts you interact with have proper account
                            security set up.
                            <br />
                        </div>
                    }
                />
            </div>
        </Page>
    )
}

export default Tou
